<template>
    <div class="md calendar-panel" ref="panel" :style="style" @click.stop>
        <div class="calendar-selector" v-if="panelMode !== 'time'">
            <cpBtn
                icon="chevron_left"
                title="往前"
                @click.prevent="getAway('prev')"
            ></cpBtn>
            <span v-if="panelMode === 'date' || panelMode === 'datetime-local'" @click="panelMode = 'month'" class="is-link thisMonth">{{ panelCaption }}</span>
            <span v-if="panelMode === 'month'" class="thisMonth">{{ panelCaption }}</span>
            <cpBtn
                icon="chevron_right"
                title="往後"
                @click.prevent="getAway('next')"
            ></cpBtn>
            <cpBtn
                v-if="removeAble"
                icon="close"
                themes="danger"
                title="刪除"
                @click.prevent="setNull"
            ></cpBtn>
        </div>
        <div v-if="panelMode === 'month'" class="calendar-month">
            <ul>
                <li 
                    v-for="item in getMonth"
                    :key="'month-'+ item.month"
                    :class="[item.thisMonth? 'is-thisMonth': '', item.isActive? 'is-active': '', item.isAble? '': 'is-disable']"
                >
                    <a @click="updateMonth(item)">{{ item.month }} 月</a>
                </li>
            </ul>
            <!-- <gRow>
                <gCell>
                    <cpBtn
                        themes="major"
                        text="本月"
                        extendClass="is-block"
                        @click="getAway('thisMonth')"
                    ></cpBtn>
                </gCell>
                <gCell>
                    <cpBtn
                        :text="panelCaption - 1 +'/'+ select.month"
                        @click="lastYear"
                        extendClass="is-block"
                    ></cpBtn>
                </gCell>
            </gRow> -->
        </div>
        <div v-if="panelMode === 'date' || panelMode === 'datetime-local'" class="calendar-day">
            <div class="week">
                <div class="title">
                    <div>一</div>
                    <div>二</div>
                    <div>三</div>
                    <div>四</div>
                    <div>五</div>
                    <div>六</div>
                    <div>日</div>
                </div>
            </div>
            <cpCalendarMiniWeek
                v-for="n in 6"

                :mainCal="select"
                :obj="getWeek[n - 1]"
                :today="today"
                :weeksn="'week'+ n"
                :key="'week'+ n"

                @sendEvent="receiveEvent"
            ></cpCalendarMiniWeek>
        </div>
        <div v-if="panelMode === 'datetime-local' || panelMode === 'time'" class="calendar-time">
            <div class="select-area">
                <select v-model="select.hour">
                    <option v-for="num in 24" :value="num - 1" :key="num">{{ $okaTool.doubleCount(num - 1) }}</option>
                </select>
                :
                <select v-if="disabledMinutes" v-model="select.minutes" disabled>
                    <option v-for="num in 60" :value="num - 1" :key="num">{{ $okaTool.doubleCount(num - 1) }}</option>
                </select>
                <select v-else v-model="select.minutes">
                    <option v-for="num in 60" :value="num - 1" :key="num">{{ $okaTool.doubleCount(num - 1) }}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    import cpCalendarMiniWeek from '@/components/cpCalendarMiniWeek'
    import gCell from '@/components/gCell'  
    import gRow from '@/components/gRow'
    import cpBtn from '@/components/cpBtn'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            cpCalendarMiniWeek,
            gCell,
            gRow,
            cpBtn,
        },
        data: function(){
            let $today = new Date(),
                _todayYear = $today.getFullYear(),
                _todayMonth = $today.getMonth() + 1,
                _todayDate = $today.getDate();

            return {
                today: { //今天
                    year: _todayYear,
                    month: _todayMonth,
                    date: _todayDate,
                },
                cal: {
                    year: _todayYear,
                    month: _todayMonth,
                },
                panelMode: 'date',
                style: {},
                top: 0, //elemet 的高度
                screenHeight: 0, //screen 的高度
                timer: null,
                speed: 100,
            }
        },
        computed: {
            ...mapState({
                id: state => state.datePicker.id,
                select: state => state.datePicker.select,
                format: state => state.datePicker.format,
                type: state => state.datePicker.type,
                target: state => state.datePicker.target,
                disabledMinutes: state => state.datePicker.disabledMinutes,
                removeAble: state => state.datePicker.removeAble,
                action: state => state.datePicker.action,
                dayRestriction: state => state.datePicker.dayRestriction,
            }),
            panelCaption: function(){
                let _panelMode = this.panelMode,
                    _format = this.format;

                let $cal = this.cal,
                    _year = $cal.year,
                    _month = $cal.month;

                let _result = '';

                if( _format === 'ROC' ) {
                    _year -= 1911;
                }

                if( _panelMode === 'date' || _panelMode === 'datetime-local' ) {
                    _result = _year +'/'+ _month;
                }else if( _panelMode === 'month' ) {
                    _result = _year;
                }

                return _result;
            },
            thisMonth: function(){
                let $today = this.today,
                    _todayYear = $today.year,
                    _todayMonth = $today.month;

                let $select = this.select,
                    _selectYear = $select.year,
                    _selectMonth = $select.month;

                let $result = {
                        year: _todayYear,
                        month: _todayMonth,
                        thisMonth: true,
                        isActive: _todayYear === _selectYear && _todayMonth === _selectMonth,
                    }

                $result.isAble = this.dayRestriction($result);

                return $result;
            },
            getMonth: function(){
                let $set = this.cal,
                    _year = $set.year;

                let $today = this.today,
                    _todayYear = $today.year,
                    _todayMonth = $today.month;

                let $select = this.select,
                    _selectYear = $select.year,
                    _selectMonth = $select.month;

                let $month = []

                for( let _i = 1; _i < 13; _i++ ) {
                    let _thisMonth = _year === _todayYear && _i === _todayMonth,
                        _isActive = _year === _selectYear && _i === _selectMonth;

                    this.pushData($month, {
                        year: _year,
                        month: _i,
                        thisMonth: _thisMonth,
                        isActive: _isActive,
                    });
                }

                return $month;
            },
            getWeek: function(){
                let $set = this.cal,
                    _year = $set.year,
                    _month = $set.month;

                let $last = new Date(_year, _month, 0),
                    $lastDate = $last.getDate(),
                    $lastDay = $last.getDay();

                let _start_Day = ($lastDay - $lastDate + 36) % 7; //算1號是星期幾

                let $weeks = [[], [], [], [], [], []],
                    $date = []

                for (let i = 1; i <= $lastDate; i++){ //推每天進 $date
                    let _day = (_start_Day + i - 1) % 7;

                    this.pushData($date, {
                        year: _year,
                        month: _month,
                        date: i,
                        day: _day,
                        thisMonth: true,
                        isActive: false,
                    });
                }

                let _before_int = (_start_Day + 6) % 7; //前面要補幾天

                if (_before_int > 0){
                    let __year = 0,
                        __month = 0;

                    if (_month === 1){
                        __year = _year - 1,
                        __month = 12;
                    } else {
                        __year = _year,
                        __month = _month - 1;
                    }

                    let _lastDay = new Date(__year, __month, 0).getDate();

                    for (let i = 0; i < _before_int; i++){
                        let _day = (_start_Day + 6 - i) % 7;

                        this.pushData($date, {
                            year: __year,
                            month: __month,
                            date: _lastDay - i,
                            day: _day,
                            thisMonth: false,
                            isActive: false,
                        }, 'unshift');
                    }
                }

                let _after_int = 42 - _before_int - $lastDate; //後面要補幾天

                if (_after_int > 0){
                    let __year = 0,
                        __month = 0;

                    if (_month === 12){
                        __year = _year + 1,
                        __month = 1;
                    } else {
                        __year = _year,
                        __month = _month + 1;
                    }

                    for (let i = 0; i < _after_int; i++){
                        let _day = ($lastDay + 8 + i) % 7;

                        this.pushData($date, {
                            year: __year,
                            month: __month,
                            date: i + 1,
                            day: _day,
                            thisMonth: false,
                            isActive: false,
                        });
                    }
                }

                $date.forEach(($date_obj, index) => { //重新整理七天一陣列
                    $weeks[Math.floor(index / 7)].push($date_obj);
                });

                return $weeks;
            }
        },
        watch: {
            id: {
                handler: function(){
                    this.init();
                    this.setPos();
                },
            },
            top: {
                handler: function(){
                    this.setPos();
                }
            },
            screenHeight: {
                handler: function(){
                    this.setPos();
                }
            },
            panelMode: {
                handler: function(){
                    this.setPos();
                }
            },
        },
        methods: {
            ...mapMutations([
                'setDatePicker',
                'initDatePicker',
                'globalClickFuncQueuePush',
                'globalClickFuncQueueClear',
            ]),
            lastYear: function(){ //按下去年同期
                let _lastYear = this.cal.year - 1;

                this.select.year = _lastYear;
                this.cal.year = _lastYear;

                if( this.type === 'date' || this.type === 'datetime-local' ) {
                    this.panelMode = this.type;
                }
            },
            runTimer: function(){
                this.clearTimer();

                this.timer = setTimeout(() => {
                    this.getElementData();
                }, this.speed);
            },
            clearTimer: function(){
                clearInterval(this.timer);
            },
            pushData: function(Array, obj, method){
                obj.isAble = this.dayRestriction(obj);

                if( method ) {
                    Array[method](obj);
                }else {
                    Array.push(obj);
                }
            },
            getElementData: function(){
                let $target = this.target || {},
                    $BoundingClientRect = $target.getBoundingClientRect;

                if( $BoundingClientRect ) {
                    this.$set(this, 'top', $target.getBoundingClientRect().top);
                }

                this.$set(this, 'screenHeight', window.innerHeight);

                this.runTimer();
            },
            getAway: function(way){ //判斷方向並取回設定的時間
                let $set = this.cal;

                if( this.panelMode === 'month' ) {

                    if (way === 'prev'){
                        $set.year = $set.year - 1;
                    } else if (way === 'next'){
                        $set.year = $set.year + 1;
                    } else if (way === 'thisMonth'){
                        $set.year = this.today.year;
                        $set.month = this.today.month
                        this.$set(this, 'panelMode', 'date')
                    }

                }else if( this.panelMode === 'date' || this.panelMode === 'datetime-local' ) {

                    if (way === 'prev'){

                        if ($set.month === 1){
                            $set.year = $set.year - 1;
                            $set.month = 12;
                        } else {
                            $set.month = $set.month - 1;
                        }
                    } else if (way === 'next'){

                        if ($set.month === 12){
                            $set.year = $set.year + 1;
                            $set.month = 1;
                        } else {
                            $set.month = $set.month + 1;
                        }
                    }
                }
            },
            updateMonth: function(obj){ //按下月份
               
                if( this.type === 'date' || this.type === 'datetime-local' ) {
                    this.cal.month = obj.month;
                    this.panelMode = this.type;
                }else if( this.type === 'month' ){

                    this.updateSelect({
                        year: obj.year,
                        month: obj.month,
                    });
                    
                    this.action();
                }
            },
            updateSelect: function(opt){
                let $select = this.select,
                    $clone = this.$okaTool.copy($select);

                if( opt && typeof opt === 'object' ) {

                    for( let _key in opt ) {
                        $clone[_key] = opt[_key]
                    }
                }
                
                this.setDatePicker({
                    select: $clone,
                });
            },
            updateCal: function(obj){ //按下日期
                let $data = obj.data,
                    _year = $data.year,
                    _month = $data.month,
                    _date = $data.date;

                this.updateSelect({
                    year: _year,
                    month: _month,
                    date: _date,
                });

                if( this.cal.year !== _year ) {
                    this.cal.year = _year;
                }

                if( this.cal.month !== _month ) {
                    this.cal.month = _month;
                }

                if( this.type === 'date' ) {
                    this.action();
                }
            },
            setNull: function(){

                this.updateSelect({
                    year: 0,
                    month: 0,
                    date: 0,
                    hour: 0,
                    minutes: 0,
                });

                this.action();
            },
            remove: function(){
                this.initDatePicker();

                this.clearTimer();
            },
            setPos: function(){ //計算定位
                let $panel = this.$refs.panel;

                let $target = this.target || {},
                    $rect = $target.getBoundingClientRect(),
                    _nodeTop = $rect.top,
                    _nodeLeft = $rect.left,
                    _nodeHeight = $target.offsetHeight,
                    _nodeWidth = $target.offsetWidth;

                let $window = window,
                    _clientWidth = $window.innerWidth,
                    _clientHeight = $window.innerHeight,
                    _panelHeight = $panel.scrollHeight,
                    _panelWidth = $panel.offsetWidth;

                let _int = 2; //緩衝

                // if( _nodeTop < 0 || _nodeLeft < 0 || _nodeTop > _clientHeight || _nodeLeft > _clientWidth ) { //超出界限
                //     this.remove();
                // }else {
                    let $result = {}

                    if( (_nodeTop + _nodeHeight) + (_int + _panelHeight) < _clientHeight ){ //優先顯示在下面
                        $result.top = (_nodeTop + _nodeHeight) + _int +'px';
                    }else if( _nodeTop - (_int + _panelHeight) > 0 ){
                        $result.top = _nodeTop - (_int + _panelHeight) +'px';
                    }else {
                        $result.top = (_nodeTop + _nodeHeight) + _int +'px';
                        $result.maxHeight = _clientHeight - _nodeTop - _nodeHeight - ( _int * 2 ) +'px';
                    }

                    if( _nodeLeft + _panelWidth < _clientWidth ){ //優先顯示靠左
                        $result.left = _nodeLeft +'px';
                    }else {
                        $result.left = _nodeLeft + _nodeWidth - _panelWidth +'px';
                    }

                    this.$set(this, 'style', $result);
                // }
            },
            init: function() {
                this.$set(this, 'cal', {
                    year: this.select.year,
                    month: this.select.month,
                });

                this.$set(this, 'panelMode', this.type);
            },
        },
        mounted: function(){
            this.setPos();
            this.runTimer();
        },
        created: function(){
            this.init();
            
            this.globalClickFuncQueuePush({
                type: 'click',
                id: 'datePickerPanel',
                func: this.remove
            });
        },
        destroyed: function(){
            this.globalClickFuncQueueClear({
                type: 'click',
                id: 'datePickerPanel',
            });
        }
    }
</script>

<style scoped lang="scss">

    .md.calendar-panel {
        position: fixed;
        z-index: 1201;
        max-width: 300px;
        overflow-y: auto;
        box-sizing: border-box;
        @extend %card;

        &::v-deep {

            .is-disable {
                cursor: not-allowed;
                
                a {
                    color: $gray !important;
                    pointer-events: none;
                    opacity: $opacity-m;
                    text-decoration: line-through;
                }
            }

            .calendar-selector {
                text-align: center;
                margin-bottom: $interval-m;
                overflow: hidden;

                a {

                    &:hover {

                    }

                    &.prevMonth {

                    }

                    &.nextMonth {

                    }

                    &.removeData {
                        float: right;
                    }
                }

                .thisMonth {
                    display: inline-block;
                    vertical-align: middle;
                    margin: 0 $interval-s;
                    border-radius: $border-radius;

                    &.is-link {
                        cursor: pointer;

                        &:hover {
                            background-color: $deep-gray;
                            color: $white;
                        }
                    }

                    &.thisMonth {
                        width: 70px;
                        text-align: center;
                        font-size: $font-size-l;
                    }
                }
            }

            .calendar-day {

                .week {

                }

                .title {

                    > div {
                        float: left;
                        width: (100% / 7);
                        text-align: center;
                        color: $gray;
                    }

                    &::after {
                        @extend %clear;
                    }
                }

                .days {

                    @for $i from 1 through 6 {

                        &.is-before-#{$i} {

                            &::before {
                                content: $content;
                                float: left;
                                width: (100% / 7) * $i;
                            }
                        }
                    }

                    .day {
                        float: left;
                        width: (100% / 7);
                        text-align: center;
                        color: $gray;
                        padding: 1px;
                        box-sizing: border-box;
                    }

                    .date {
                        $size: 26px;

                        display: inline-block;
                        vertical-align: middle;
                        height: $size;
                        width: $size;
                        line-height: $size;
                        font-size: $font-size-s;
                        color: $deep;
                        border-radius: $size;
                        transition: $transition;
                        cursor: pointer;
                      
                        &:hover {
                            background-color: $deep-gray;
                            color: $white;
                        }
                    }

                    .is-active {

                        .date {
                            background-color: $minor-color;
                            color: $white;

                        }
                    }

                    .is-today {

                        .date {
                            background-color: $major-color;
                            color: $white;

                            &:hover {
                                background-color: $opacity-h;
                            }
                        }
                    }

                    .disable {
                        .date {
                            color: $gray;
                            pointer-events: none;

                            &:hover {
                                background-color: $gray;
                                color: $white;
                            }
                        }
                    }

                    .not-thisMonth {

                        .date {
                            color: $gray;

                            &:hover {
                                background-color: $gray;
                                color: $white;
                            }
                        }
                    }

                    &::after {
                        @extend %clear;
                    }
                }

                + .calendar-time {
                    margin-top: $interval-s;
                    border-top: $border;
                    padding-top: $interval-m;

                }
            }

            .calendar-month {

                ul {
                    @extend %reset;

                    li {
                        display: inline-block;
                        box-sizing: border-box;
                        padding: $interval-xs;
                        width: 25%;

                        &.is-thisMonth {

                            a {
                                color: $major-color;

                                &:hover {
                                    color: $white;
                                }
                            }
                        }

                        &.is-active {

                            a {
                                background-color: $major-color;
                                color: $white;
                            }
                        }
                    }

                    a {
                        display: block;
                        padding: $interval-xs;
                        text-align: center;
                        color: inherit;
                        border-radius: $border-radius;
                        cursor: pointer;

                        &:hover {
                            background-color: $deep-gray;
                            color: $white;
                        }
                    }
                }
            }

            .calendar-time {
                display: flex;

                .select-area {
                    flex: 1;
                }

                select {
                    width: 80px;
                }

                a {

                }
            }
        }
        
    }
</style>
